import { usePlayer, useRound, useStage } from "@empirica/core/player/classic/react";
import React from "react";
import { ChatbotChatStage } from "./ai/ChatbotChatStage";
import { ChatbotContextStage } from "./ai/ChatbotContextStage";
import { ExperimentIntroStage } from "./intro-exit/ExperimentIntroStage";
import { PostChatbotPetQuestion } from "./intro-exit/PostChatbotPetQuestion";
import { NegotiationDiscussionStage } from "./negotiation/NegotiationDiscussionStage";
import { NegotiationFinalOfferStage } from "./negotiation/NegotiationFinalOfferStage";
import { NegotiationInitialResultStage } from "./negotiation/NegotiationInitialResultStage";
import { NegotiationRulesStage } from "./negotiation/NegotiationRulesStage";
import { NegotiationStage } from "./negotiation/NegotiationStage";
import { Stage1GameRulesStage } from "./stage1/Stage1GameRulesStage";
import { Stage1ResultStage } from "./stage1/Stage1ResultStage";
import { Stage1TaskStage } from "./stage1/Stage1TaskStage";
import { Stage2GameRulesStage } from "./stage2/Stage2GameRulesStage";
import { Stage2TaskStage } from "./stage2/Stage2TaskStage";
import { Stage2ResultStage } from "./stage2/Stage2ResultStage";

function normalizeChatbotArm(value) {
  if (value === "treatment") {
    return "treatment";
  }

  return "control";
}

export function Stage() {
  const player = usePlayer();
  const round = useRound();
  const stage = useStage();

  if (!stage || !round) {
    return (
      <div className="w-full px-8 py-6 text-center text-gray-500">
        Loading...
      </div>
    );
  }

  if (round.get("task") === "experiment_intro") {
    return <ExperimentIntroStage />;
  }

  if (round.get("task") === "stage1_instructions") {
    return <Stage1GameRulesStage />;
  }

  if (round.get("task") === "stage1_task") {
    return <Stage1TaskStage />;
  }

  if (round.get("task") === "stage1_result") {
    return <Stage1ResultStage />;
  }

  if (round.get("task") === "stage2_setup") {
    return <Stage2GameRulesStage />;
  }

  if (round.get("task") === "negotiation_rules") {
    return <NegotiationRulesStage />;
  }

  if (round.get("task") === "chatbot_context") {
    return <ChatbotContextStage />;
  }

  if (round.get("task") === "chatbot_chat") {
    const chatbotArm = normalizeChatbotArm(player.get("chatbotArm"));
    const chatMode = chatbotArm === "treatment" ? "negotiation" : "filler";
    return <ChatbotChatStage chatMode={chatMode} />;
  }

  if (round.get("task") === "post_chatbot_pet") {
    return <PostChatbotPetQuestion />;
  }

  if (round.get("task") === "negotiation_initial") {
    return <NegotiationStage />;
  }

  if (round.get("task") === "negotiation_initial_result") {
    return <NegotiationInitialResultStage />;
  }

  if (round.get("task") === "negotiation_discussion") {
    return <NegotiationDiscussionStage />;
  }

  if (round.get("task") === "negotiation_final") {
    return <NegotiationFinalOfferStage />;
  }

  if (round.get("task") === "stage2_task") {
    return <Stage2TaskStage />;
  }

  if (round.get("task") === "stage2_result") {
    return <Stage2ResultStage />;
  }

  return <div>Unknown task</div>;
}
